export const buildEnvironment = {
"buildId":"492051",
"buildDate":"2024-08-14T08:31:35.256Z",
"buildTimeStamp":1723624295256,
"ngVersion":"13.3.2",
"version":"6.0.4751",
"api":"21.01",
"environment":"prod",
"production":true
};